import { useState, useEffect } from "react";
import axios from "axios";
import { config } from "../../utils/config";
import { getCookie } from "../../utils/cookieHandler";

const useRentalPartnersLogic = () => {
  const [partners, setPartners] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedPartner, setSelectedPartner] = useState(null);
  const [partnerVehicles, setPartnerVehicles] = useState([]);
  const [partnerFleets, setPartnerFleets] = useState([]);
  const [vehiclesLoading, setVehiclesLoading] = useState(false);

  const rentalPartnerRole = process.env.REACT_APP_PARTNER_ROLE;

  const fetchPartners = async () => {
    try {
      setLoading(true);
      const token = getCookie("_AT");
      
      // Fetch all users. Note: This might be inefficient for large datasets, 
      // but without a dedicated 'list partners' endpoint or query param support, this is the safest quick implementation.
      // Ideally we would pass ?role=... if the backend supports it.
      const response = await axios.get(`${config.apiUrl}/api/users`, {
        headers: { Authorization: `Bearer ${token}` }
      });

      const allUsers = response.data?.data || [];
      // Filter for Rental Partners
      const filteredPartners = allUsers.filter(user => {
          const roleId = user.role?.id || user.role;
          return roleId === rentalPartnerRole;
      });

      setPartners(filteredPartners);
    } catch (error) {
      console.error("Error fetching rental partners:", error);
    } finally {
      setLoading(false);
    }
  };

  const fetchPartnerVehicles = (partner) => {
    setSelectedPartner(partner);
    if (partner.vehicles && Array.isArray(partner.vehicles)) {
         setPartnerVehicles(partner.vehicles);
    } else {
         setPartnerVehicles([]);
    }
    if (partner.fleets && Array.isArray(partner.fleets)) {
        setPartnerFleets(partner.fleets);
    } else {
        setPartnerFleets([]);
    }
  };
  
  const closeVehicleModal = () => {
      setSelectedPartner(null);
      setPartnerVehicles([]);
      setPartnerFleets([]);
  }

  useEffect(() => {
    if (rentalPartnerRole) {
      fetchPartners();
    }
  }, [rentalPartnerRole]);

  return {
    partners,
    loading,
    selectedPartner,
    partnerVehicles,
    partnerFleets,
    vehiclesLoading,
    fetchPartnerVehicles,
    closeVehicleModal
  };
};

export default useRentalPartnersLogic;
